(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("react-is"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "react-is"], factory);
	else if(typeof exports === 'object')
		exports["Recharts"] = factory(require("react"), require("react-dom"), require("react-is"));
	else
		root["Recharts"] = factory(root["React"], root["ReactDOM"], root["ReactIs"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__5442__, __WEBPACK_EXTERNAL_MODULE__6003__, __WEBPACK_EXTERNAL_MODULE__2751__) => {
return 